import React from "react"
import * as styles from "./Spacer.module.scss"
import { SpacerProps } from "./SpacerProps"
import { BackgroundColor } from "../../constants/BackgroundColor"

export function Spacer(props: SpacerProps) {
    const className = props?.backgroundColor === BackgroundColor.alt ? styles.mainAlt : styles.main
    return <div className={className} />
}
